<template>
  <span @click="setEditDialog(true)">
    <v-edit-dialog
      v-if="decimalDialog && column.editor"
      ref="decimal-dialog"
      v-model="decimalDialog"
      lazy
      large
      cancel-text="Отмена"
      save-text="Ок"
      @cancel="closeDialog()"
      @open="selected = item"
      @save="change(item)"
    >
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        size="20"
        width="2"
        class="mt-0"
      />
      <div
        v-if="!loading"
        class="link"
      >
        {{ item }}
      </div>
      <template v-slot:input>
        <DecimalEditor
          v-model="item"
          :scale="column.scale"
          class="mt-3 mb-2"
          :label="column.title"
        />
      </template>
    </v-edit-dialog>
    <v-tooltip
      v-else
      top
    >
      <template v-slot:activator="{ on }">
        <span
          :class="canEdit ? 'link' : ''"
          v-on="on"
        >{{ item }}</span>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </span>
</template>
<script>
import {
  updateVolume,
  updateWeight,
  updateCargoPlaces,
} from "../../../backend/routesApi.js";
export default {
  props: ["value", "routeItem", "routeId", "column", "headers", "canEdit"],
  data() {
    return {
      selected: null,
      loading: false,
      decimalDialog: false,
      item: 0,
      tooltip: "",
    };
  },
  watch: {
    value: {
      handler(value) {
        if (value && this.routeItem.inCar) {
          this.item = value.routeItem;
          this.tooltip = "Фактические данные";
        } else if (
          value &&
          !this.routeItem.inCar &&
          value.routeItem === value.shippingInfo
        ) {
          this.item = value.routeItem;
          this.tooltip = "Данные с инфо по поставке";
        } else if (
          value &&
          !this.routeItem.inCar &&
          value.routeItem !== value.shippingInfo
        ) {
          this.item = value.routeItem;
          this.tooltip = "Фактические данные";
        } else {
          this.item = 0;
          this.tooltip = "Данные с инфо по поставке";
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$watch(
      () => {
        return this.decimalDialog;
      },
      newVal => {
        if (newVal) {
          this.$refs["decimal-dialog"].isActive = true;
        }
      },
    );
  },
  methods: {
    closeDialog() {
      this.item = this.selected;
      this.setEditDialog(false);
      this.selected = null;
    },
    async change(value) {
      try {
        this.loading = true;
        if (this.column.name === "volume") {
          await updateVolume(this.routeId, this.routeItem.id, value);
        }
        if (this.column.name === "weight") {
          await updateWeight(this.routeId, this.routeItem.id, value);
        }
        if (this.column.name === "cargoPlaces") {
          await updateCargoPlaces(this.routeId, this.routeItem.id, value);
        }
        this.loading = false;
        const routeItem = { ...this.routeItem };
        routeItem[this.column.name].routeItem = value;
        this.$store.commit("route/setEditableRouteItem", routeItem);
        this.$store.dispatch("route/changeRouteItem", this.column.name);
        this.setEditDialog(false);
        this.showInfo("Изменения сохранены");
      } catch (error) {
        if (error.message) {
          this.loading = false;
          this.showError(error.message);
        } else {
          this.loading = false;
          throw error;
        }
      }
    },
    setEditDialog(value) {
      if (!this.canEdit) {
        return;
      }
      this.decimalDialog = value;
      this.$emit("changeColumnEditor", value);
    },
  },
};
</script>
